// extracted by mini-css-extract-plugin
export default {"wrapper":"PinModal_wrapper__NffF9","close":"PinModal_close__jnFzx","title":"PinModal_title__UYY6R","confirm-btn":"PinModal_confirm-btn__jMHsY"};